
/*@jsxRuntime automatic @jsxImportSource react*/
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    a: "a"
  }, props.components);
  return <><_components.h1>{"Setup"}</_components.h1>{"\n"}<_components.p>{"Check Run Reporter supports a number of\n"}<_components.a href="/docs/tool-integrations">{"test and style-checking"}</_components.a>{" tools. If we don't directly\nsupport your tools yet, you can easily\n"}<_components.a href="/docs/manual-setup">{"upload reports manually"}</_components.a>{", but please\n"}<_components.a href="https://github.com/check-run-reporter/feedback/issues/new">{"let use know"}</_components.a>{" that\nwe're missing something you need."}</_components.p></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
export default MDXContent;


export const filename = "docs._index.mdx";
export const headers = typeof attributes !== "undefined" && attributes.headers;
export const meta = typeof attributes !== "undefined" && attributes.meta;
export const handle = typeof attributes !== "undefined" && attributes.handle;
    